import React from 'react'
import PropTypes from 'prop-types'
import { Spin } from 'antd'
import { logout } from 'Evolve'

export default class extends React.PureComponent {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  }

  componentDidMount = () => {
    this.props.dispatch(logout())
  }

  render = () => (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f5f5f5',
    }}>
      <img src="/img/lead-pm-logo.png" alt="LeadPM" style={{ height: 48, marginBottom: 32 }} />
      <Spin size="large" />
      <p style={{ marginTop: 20, color: '#555', fontSize: 16 }}>Logging out...</p>
    </div>
  )

}
